import { AgentEffectDescription, DefType, GameExtension } from "~/business";
import { DefInstance, Entity, EntityRepository } from "~/utils";

export type BattleCard = DefInstance<"BattleCard">;

export type BattleCardProps = {
  name: string;
  level: 1 | 2 | 3;
  effects: AgentEffectDescription[][];
  controlSlotId?: string;
  extension?: GameExtension;
};

class BattleCardRepository extends EntityRepository<BattleCardProps & Entity> {
  fromDef(def: BattleCardProps & Entity): BattleCard {
    const cardDef = battleCardsDefRepository.getById(def.id);
    return DefInstance.fromDef({
      defId: cardDef.id,
      defName: DefType.BattleCard,
    });
  }
}

export const battleCardsDefRepository = new BattleCardRepository({
  entities: [],
});
